module.exports = __webpack_public_path__ + "static/media/add_reflect.8a2fb807.svg";